// @flow
import { teamSettings } from 'common/middleware/api';
import { ApiError } from 'common/modules/api';
import { injectError } from './error';
import TaskProfileActions from 'common/redux/actions/taskProfile';

export default class TeamSettingsActions {
    static FETCH_TEAM_SETTINGS_START = 'FETCH_TEAM_SETTINGS_START';
    static FETCH_TEAM_SETTINGS_COMPLETE = 'FETCH_TEAM_SETTINGS_COMPLETE';
    static INJECT_TEAM_SETTINGS = 'INJECT_TEAM_SETTINGS';

    static fetchTeamSettings(clientId: string, teamId: string) {
        const params = {
            clientId,
            teamId
        };

        return dispatch => {
            dispatch(TeamSettingsActions.startFetchingTeamSettings());
            teamSettings
                .fetch(params)
                .then(teamSettings => {
                    dispatch(
                        TeamSettingsActions.injectTeamSettings(
                            teamSettings,
                            params
                        )
                    );
                })
                .catch(error => {
                    dispatch(
                        TeamSettingsActions.completeFetchingTeamSettings()
                    );
                    if (error instanceof ApiError) {
                        dispatch(injectError(error));
                    } else {
                        throw error;
                    }
                });
        };
    }

    static fetchTeamSettingsAndTaskProfile(clientId: string, teamId: string) {
        const params = {
            clientId,
            teamId
        };

        return dispatch => {
            dispatch(TeamSettingsActions.startFetchingTeamSettings());
            teamSettings
                .fetch(params)
                .then(teamSettings => {
                    dispatch(
                        TeamSettingsActions.injectTeamSettings(
                            teamSettings,
                            params
                        )
                    );
                    dispatch(
                        TaskProfileActions.fetchTaskProfile(
                            clientId,
                            teamId,
                            teamSettings.activeTaskProfileId
                        )
                    );
                })
                .catch(error => {
                    dispatch(
                        TeamSettingsActions.completeFetchingTeamSettings()
                    );
                    if (error instanceof ApiError) {
                        dispatch(injectError(error));
                    } else {
                        throw error;
                    }
                });
        };
    }

    static startFetchingTeamSettings(): Object {
        return {
            type: TeamSettingsActions.FETCH_TEAM_SETTINGS_START
        };
    }

    static completeFetchingTeamSettings(): Object {
        return {
            type: TeamSettingsActions.FETCH_TEAM_SETTINGS_COMPLETE
        };
    }

    static injectTeamSettings(teamSettings, params): Object {
        return {
            type: TeamSettingsActions.INJECT_TEAM_SETTINGS,
            response: teamSettings,
            params
        };
    }
}
